import { Grid } from '@mui/material';
import {
  WsColors,
  WsIconApplications,
  WsIconMapping,
  WsIconSubmitted,
  WsTitleColors,
  WsTitleHeader,
} from 'wisestep-base';
interface UploadStatusProps {
  selected: number;
  allowed: number;
  notAllowed: number;
  success: number;
  failed: number;
}
const UploadCandidatesStatus = ({ allowed, notAllowed, success, failed }: UploadStatusProps) => (
  <Grid container direction="row" p={3}>
    <Grid item xs={4}>
      <WsTitleHeader
        title={`${allowed} / ${notAllowed}`}
        subtitle="Total Selected (Allowed / Not Allowed)"
        color={WsTitleColors.PRIMARY500}
        startIcon={<WsIconSubmitted color2={WsColors.TheBlues500} color={WsColors.TheBlues800} />}
      />
    </Grid>
    <Grid item xs={4}>
      <WsTitleHeader
        title={`${allowed}`}
        subtitle="Scheduled"
        color={WsTitleColors.YELLOW}
        startIcon={<WsIconMapping color2={WsColors.TheBlues500} color={WsColors.TheBlues800} />}
      />
    </Grid>
    <Grid item xs={4}>
      <WsTitleHeader
        title={`${success} / ${failed}`}
        subtitle="Uploaded (Successful / Failed)"
        color={WsTitleColors.PRIMARY500}
        startIcon={
          <WsIconApplications color2={WsColors.TheBlues500} color={WsColors.TheBlues800} />
        }
      />
    </Grid>
  </Grid>
);

export default UploadCandidatesStatus;
